import { Abbr } from "@site/src/components";

export default function SecondPersonPlural() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td> my </td>
          <td>vasъ/vy</td>
          <td>vasъ </td>
          <td>vamъ/vy </td>
          <td>vami</td>
          <td>vasъ</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td> vy </td>
          <td>vas </td>
          <td>vas </td>
          <td>vam </td>
          <td>vami</td>
          <td>vas</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td> vy </td>
          <td>vas </td>
          <td>vas </td>
          <td>vam </td>
          <td>vámi</td>
          <td>vas</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td> vy </td>
          <td>vas </td>
          <td>vas </td>
          <td>vam </td>
          <td>vámy</td>
          <td>vas</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td> vy </td>
          <td>vas </td>
          <td>vas </td>
          <td>vam </td>
          <td>vamy</td>
          <td>vas</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td> wy </td>
          <td>was </td>
          <td>was </td>
          <td>wam </td>
          <td>wami</td>
          <td>was</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td> wë </td>
          <td>was/wôs</td>
          <td>was/wôs</td>
          <td>wóm </td>
          <td>wami</td>
          <td>was/wôs</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td> wy </td>
          <td>was </td>
          <td>was </td>
          <td>wam </td>
          <td>wami</td>
          <td>was</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td> wy </td>
          <td>was </td>
          <td>was </td>
          <td>wam </td>
          <td>wami</td>
          <td>was/wami</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td> vy </td>
          <td>vás </td>
          <td>vás </td>
          <td>vám </td>
          <td>vámi</td>
          <td>vás</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td> vy </td>
          <td>vás </td>
          <td>vás </td>
          <td>vám </td>
          <td>vami</td>
          <td>vás</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td> vi </td>
          <td>vas </td>
          <td>vas </td>
          <td>vam </td>
          <td>vami</td>
          <td>vas</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td> vî </td>
          <td>vâs/vas</td>
          <td>vâs/vas</td>
          <td>vàma/vam</td>
          <td>vàma</td>
          <td>vàma</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td> vie </td>
          <td>vas/ve </td>
          <td>—</td>
          <td>vam/vi</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td> víe/vij</td>
          <td>vas/vi </td>
          <td>—</td>
          <td>vi/vam</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>vy</b>
          </td>
          <td>
            <b>vas</b>
          </td>
          <td>
            <b>vas</b>
          </td>
          <td>
            <b>vam</b>
          </td>
          <td>
            <b>vami</b>
          </td>
          <td>
            <b>vas</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
